import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { TransferEmployerCloseOfficeService } from '../transfer-employer-close-office.service';
import { ManageEmployeeListModel } from '../../../model/manageEmployeeListModel';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { StorageService } from '../../../shared/security/StorageService';
import { CompleteFunctionService } from '../../../shared/utils/complete-function.service';
import { CompleteFunctionRequestModel } from '../../../model/completeFunctionRequestModel';
import { CompleteFunctionResponseModel } from '../../../model/completeFunctionResponseModel';
import { MessageModel } from '../../../model/models';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { SearchEmployeesToManageResponseModel } from '../../../model/searchEmployeesToManageResponseModel';
import { SelectEmployeesToManageRequestModel } from '../../../model/selectEmployeesToManageRequestModel';

@Component({
  selector: 'app-sever-transfer-receipt',
  templateUrl: './sever-transfer-receipt.component.html',
  styleUrls: ['./sever-transfer-receipt.component.css']
})
export class SeverTransferReceiptComponent implements OnInit , OnDestroy{
 

  manageEmployeeList : Array<ManageEmployeeListModel> =[];
  startFunction: StartFunctionResponseModel = {};
  workflow: WorkflowModel = new WorkflowModel();
  title: string = "";
  now: Date = new Date();
  userMessages: Array<MessageModel> = [];
  completeFunctionRequestModel : CompleteFunctionRequestModel = new CompleteFunctionRequestModel();
  completeFunctionResponseModel : CompleteFunctionResponseModel = new CompleteFunctionResponseModel();
  searchEmployeesToManageResponseModel: SearchEmployeesToManageResponseModel = new SearchEmployeesToManageResponseModel();
  selectEmployeesModel: SelectEmployeesToManageRequestModel = new SelectEmployeesToManageRequestModel();
  
  constructor(private transferEmployerCloseOfficeService : TransferEmployerCloseOfficeService,
              private storage: StorageService,
              private currentPageWatcher : CurrentPageWatcherService,
              private completeFunctionService : CompleteFunctionService,
              private router : Router,
              private startFunctionService : StartFunctionService) { 

    this.startFunction = this.storage.getStartFunctionData();
    if (this.startFunction != null && this.startFunction != undefined && this.startFunction.Workflow != null) {
      this.title = this.startFunction.Workflow.WorkflowDisplayName;
    }

    this.transferEmployerCloseOfficeService.getNotifyWorkflowModel().subscribe(
      (workflowData : WorkflowModel)=>{
        this.workflow=workflowData;
        this.completeFunctionRequestModel.WorkflowID = workflowData.WorkflowID;
        this.completeFunctionRequestModel.CurrentStepIndex = workflowData.CurrentStepIndex;
        this.completeFunctionRequestModel.OrderNumber=null;
        console.log("this.completeFunctionRequestModel : ", this.completeFunctionRequestModel);

      }
    );

    this.transferEmployerCloseOfficeService.getNotifyManageEmployeeList().subscribe(emplyeeListData=>{
      this.manageEmployeeList = emplyeeListData;
    });
    
    this.transferEmployerCloseOfficeService.getNotifySearchEmployeesToManageResponseModel().subscribe(searchEmployeesToManageResponseData=>{
      this.searchEmployeesToManageResponseModel = searchEmployeesToManageResponseData;
    });

    this.transferEmployerCloseOfficeService.getNotifySelectEmployeesRequestModel().subscribe( selectEmployeesData=>{
      this.selectEmployeesModel = selectEmployeesData;
    });
  }

  ngOnInit() {
    this.currentPageWatcher.pageChanged().emit(this.title);

    this.completeFunctionService.completeFunction(this.completeFunctionRequestModel).subscribe(response => {
      response.UserMessages.forEach(msg => {
        this.userMessages.push(msg);
      });
      this.currentPageWatcher.sendUserMessages(this.userMessages);
      if (response.Summary == 0) {
        this.completeFunctionResponseModel = response;
        this.userMessages = [];
      }
      if (response.Summary == 1) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        this.userMessages = [];
      }
      if (response.Summary == 2) {
        this.router.navigate(["/home"]);
        this.userMessages = [];
      }
    })
  }


  returnToHome(){
    this.router.navigate(["/home"]);
  }

  ngOnDestroy(): void {
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
  }

  printPage(){
    window.print();
  }
  //back browser button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.router.navigate(["/severTransferReview"]).then(() => {
      this.startFunctionService.getNotifyStepInProgress().emit(false);
      this.transferEmployerCloseOfficeService.getNotifyManageEmployeeList().emit(this.manageEmployeeList);
      this.transferEmployerCloseOfficeService.getNotifyWorkflowModel().emit(this.workflow);
      this.transferEmployerCloseOfficeService.getNotifySearchEmployeesToManageResponseModel().emit(this.searchEmployeesToManageResponseModel);
      this.transferEmployerCloseOfficeService.getNotifySelectEmployeesRequestModel().emit(this.selectEmployeesModel);

    });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/broker/transfer-employer-close-office/sever-transfer-receipt/sever-transfer-receipt.component.ts